import axios from 'axios';
import { getToken, getTokenCookie } from '../components/User/Auth';
export default function configureApiRestService() {
   axios.defaults.baseURL = process.env.REACT_APP_API_GATEWAY_BASE_URL;
   axios.defaults.headers.common['Content-Type'] = 'application/json';
   axios.defaults.headers.common['Accept'] = 'application/json';
   axios.defaults.headers.common['X-Tenant'] = process.env.REACT_APP_CODE_TENANT;
   axios.defaults.headers.common['X-ClientId'] = process.env.REACT_APP_CLIENT_ID;
   axios.defaults.headers.common['Token'] = process.env.REACT_APP_SERVIALAMO_API;
   if (getToken() !== null) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
   }else if (getTokenCookie() !== null) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + getTokenCookie();
   }
}